<script setup>
import DefaultButton from "@/components/onsiteEditor/components/buttons/DefaultButton.vue";
import BaseModal from "@/components/global/modals/BaseModal.vue";
import CustomCheckbox from "../../../global-themed/CustomCheckbox.vue";
import {ref} from "vue";

const emit = defineEmits(['close', 'confirm']);
const confirmation = ref(false)
</script>

<template>
  <BaseModal @close="emit('close')">
    <template #heading>
      Please Confirm the Following Before You Proceed:
    </template>
    <div class="tw-flex tw-max-w-[700px] tw-flex-col tw-justify-center tw-gap-4 tw-text-base tw-text-slate-200">
      <div class="tw-text-left">
        <span class="tw-font-bold">Continued SEO Performance:</span><br>
        All SEO changes previously implemented will remain active on the client’s website
        as long as the Onsite Optimizer script remains installed and your Hike Agency account is active.
      </div>
      <div class="tw-text-left">
        <span class="tw-font-bold">Client Communication:</span><br>
        It is essential that you inform your client that the ongoing SEO benefits are powered by
        the Onsite Optimizer script. Ensuring they understand this will help maintain the effectiveness of the SEO
        changes you have implemented.
      </div>

      <div class="tw-mx-5 tw-flex tw-justify-center tw-gap-3 tw-text-center tw-text-sm">
        <CustomCheckbox
          id="confirmation"
          v-model="confirmation"
        />
        I confirm that I have communicated to my client that the SEO enhancements made to their website
        are dependent on the continued presence of the Onsite Optimizer script.
      </div>
    </div>
    <template #footer>
      <div class="tw-flex tw-w-full tw-justify-center">
        <div class="tw-w-1/3">
          <DefaultButton
            class="tw-mt-5"
            :disabled="!confirmation"
            @click="emit('confirm')"
          >
            Proceed
          </DefaultButton>
        </div>
      </div>
    </template>
  </BaseModal>
</template>
